__turbopack_context__.v({
  "className": "nacelle_4f12ad47-module__Q85gtW__className",
  "variable": "nacelle_4f12ad47-module__Q85gtW__variable",
});
